import { makeStyles } from '@material-ui/core'

export const styles = makeStyles((theme) => ({
  root: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: '552px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  root2: {
    width: '900px',
    [theme.breakpoints.only('md')]: {
      width: '43rem',
    },
    [theme.breakpoints.only('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },

  container: {
    width: '900px',
    display: 'flex',
    justifyContent: 'center',
  },

  cardSelectImg: {
    height: '2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    margin: '1.5rem',
    padding: '1.2rem',
  },
}))
